import styled from "styled-components";
import bg from "../../assets/img/JoinCommunityBg.png";
import bgDark from "../../assets/img/JoinCommunityBgDark.png";

export const FaqWrapper = styled.div`
  padding: 50px 250px;
  width: 100%;
  background: ${(props) => (props.theme == "dark" ? `url(${bg})` : `url(${bgDark})`)} repeat-y center;
  background-size: contain;
  @media (max-width: 991.98px) {
    padding: 50px 0;
  }
`;

export const FaqMain = styled.div`
  margin: 50px 0;
  width: 100%;
  & h2 {
    font-family: "Inter";
    font-style: normal;
    font-weight: 600;
    font-size: 36px;
    line-height: 126.2%;
    color: ${(props) => props.theme.textColor};
    margin-bottom: 10px;
  }
  & span {
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 126.2%;
    color: ${(props) => props.theme.textColor};
  }
`;

export const FaqSection = styled.div`
  flex-direction: column;
  margin: 40px 0;
  max-width: 900px;
  & h3 {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 28px;
    line-height: 126.2%;
    color: ${(props) => props.theme.textColor};
  }
  & p {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 300;
    font-size: 18px;
    line-height: 126.2%;
    margin: 20px 0;
    color: ${(props) => props.theme.textColor};
    & li {
      margin: 10px 0;
    }
    & a {
      color: #0088cc;
      text-decoration: underline;
    }
  }
`;
